import React, { useState } from "react";
import {
  Button,
  Card,
  Container,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { SoldArticlesStat } from "../components/stats/SoldArticlesStat";
import { AverageDeliveryWaitStat } from "../components/stats/AverageDeliveryWaitStat";

type StatKey = "sold-articles" | "avg-delivery-wait";

export const Stats = () => {
  const [activeStat, setActiveStat] = useState<StatKey | null>(null);

  return (
    <Container size="md" py="md">
      <Stack gap="md">
        <Group justify="space-between" align="center">
          <Title order={3}>Statistika</Title>
          <Text size="sm" color="dimmed">
            <Link to="/" style={{ textDecoration: "underline" }}>
              Natrag na narudžbe
            </Link>
          </Text>
        </Group>

        <Card withBorder radius="md" padding="lg">
          <Group justify="space-between" align="center">
            <Stack gap="xs">
              <Text fw={600}>Prodanih artikala</Text>
              <Text size="sm" color="dimmed">
                Tablica svih artikala i broj prodanih
              </Text>
            </Stack>
            <Button onClick={() => setActiveStat("sold-articles")}>
              Otvori
            </Button>
          </Group>
        </Card>

        <Card withBorder radius="md" padding="lg">
          <Group justify="space-between" align="center" gap="sm">
            <Stack gap="xs">
              <Text fw={600}>Prosječno vrijeme čekanja po dostavi</Text>
              <Text size="sm" color="dimmed">
                Usporedba vremena narudžbe i završetka dostave
              </Text>
            </Stack>
            <Button onClick={() => setActiveStat("avg-delivery-wait")}>
              Otvori
            </Button>
          </Group>
        </Card>

        {activeStat === "sold-articles" && (
          <Card withBorder radius="md" padding="lg">
            <SoldArticlesStat />
          </Card>
        )}

        {activeStat === "avg-delivery-wait" && (
          <Card withBorder radius="md" padding="lg">
            <AverageDeliveryWaitStat />
          </Card>
        )}
      </Stack>
    </Container>
  );
};
